(function (window) {
  if (!document.querySelector('.big-logo')) {
    return;
  }

  maskPaths = {};
  gsap.set(`.big-logo`, { opacity: 1 });

  ['antenna-left', 'antenna-right', 'proboscis'].forEach((pathClass) => {
    const path = document.querySelector(`svg.${pathClass} mask path`);
    const pathName = pathClass.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });

    if (path !== null) {
      var length = path.getTotalLength();
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;

      maskPaths[pathName] = path;
    }
  });

  const bodyMask = document.querySelector(`svg.body mask rect`);

  // thicken the wings
  ['wing-l-outline', 'wing-r-outline'].forEach((elClass) => {
    const el = document.querySelector(`.big-logo .${elClass}`);
    el.after(el.cloneNode(true));
    el.after(el.cloneNode(true));
  });

  gsap.set(maskPaths.antennaLeft.parentNode.parentNode, {
    rotation: '30',
    transformOrigin: '100% 100%',
  });
  gsap.set(maskPaths.antennaRight.parentNode.parentNode, {
    rotation: '-30',
    transformOrigin: '0 100%',
  });
  gsap.set(bodyMask, {
    scaleY: 0,
    transformOrigin: '50% 50%',
  });

  gsap.set('.wing-l', {
    rotateY: 90,
    opacity: 0,
  });
  gsap.set('.wing-r', {
    rotateY: -90,
    opacity: 0,
  });

  let flapLock = true;

  function bodyReveal() {
    let tl = new gsap.timeline();
    tl.to(
      bodyMask,
      {
        duration: 0.5,
        ease: 'power3.out',
        scaleY: 1,
      },
      0
    );

    return tl;
  }

  function leftAntennaReveal() {
    let tl = new gsap.timeline();
    tl.to(
      maskPaths.antennaLeft,
      {
        duration: 1,
        ease: 'power3.out',
        strokeDashoffset: 0,
      },
      0.4
    )
      .to(
        maskPaths.antennaLeft.parentNode.parentNode,
        {
          duration: 1,
          ease: 'sine.out',
          rotation: -7,
        },
        0.4
      )
      .to(maskPaths.antennaLeft.parentNode.parentNode, {
        duration: 0.5,
        ease: 'sine.inOut',
        rotation: 0,
      });

    return tl;
  }

  function rightAntennaReveal() {
    let tl = new gsap.timeline();
    tl.to(
      maskPaths.antennaRight,
      {
        duration: 1,
        ease: 'power3.out',
        strokeDashoffset: 0,
      },
      0.45
    )
      .to(
        maskPaths.antennaRight.parentNode.parentNode,
        {
          duration: 1,
          ease: 'sine.out',
          rotation: 7,
        },
        0.45
      )
      .to(maskPaths.antennaRight.parentNode.parentNode, {
        duration: 0.5,
        ease: 'sine.inOut',
        rotation: 0,
      });

    return tl;
  }

  function wingsDown() {
    let tl = new gsap.timeline();
    tl.set(
      '.wing-l, .wing-r',
      {
        opacity: 1,
      },
      0.3
    ).to(
      '.wing-l, .wing-r',
      {
        rotationY: 0,
        duration: 3,
        ease: 'expo.out',
        onComplete: () => {
          flapLock = false;
        },
      },
      0.3
    );
    return tl;
  }

  let blur = { px: 0 };

  function wingsBlur() {
    let tl = new gsap.timeline();
    tl.set(
      blur,
      {
        px: 2,
      },
      0.3
    ).to(
      blur,
      {
        px: 0,
        duration: 0.8,
        ease: 'expo.out',
      },
      0.3
    );
    return tl;
  }

  let revealTl = new gsap.timeline({ paused: true });

  revealTl
    .add(bodyReveal(), 0)
    .add(leftAntennaReveal(), 0)
    .add(rightAntennaReveal(), 0)
    .add(wingsDown(), 0)
    .add(wingsBlur(), 0)
    .to(
      maskPaths.proboscis,
      {
        duration: 3,
        ease: 'power3.out',
        strokeDashoffset: 0,
      },
      1.5
    );

  let revealStepped = new gsap.timeline();

  if (document.querySelector('html').classList.contains('checking-age')) {
    document.addEventListener('age-verified', (e) => {
      startButterfly(200);
    });
  } else {
    startButterfly(1000);
  }

  function startButterfly(delay) {
    setTimeout(() => {
      let lastBlur;
      revealStepped.fromTo(
        revealTl,
        {
          progress: 0,
        },
        {
          progress: 1,
          duration: revealTl.totalDuration(),
          ease: `steps(${Math.round(revealTl.totalDuration() * 13)})`,
          onUpdate: () => {
            if (blur.px != lastBlur) {
              gsap.set('.wing-l, .wing-r', { filter: 'blur(' + blur.px + 'px)' });
              lastBlur = blur.px;
            }
          },
        }
      );
    }, delay);
  }

  let flapTl = new gsap.timeline({ paused: true });

  const upBeat = 0.8;
  const downBeat = 1.2;

  function flapTlWing() {
    let tl = new gsap.timeline();
    tl.to(
      '.wing-l',
      {
        rotationY: 85,
        duration: upBeat,
        ease: 'pow3.inOut',
      },
      0
    )
      .to(
        '.wing-r',
        {
          rotationY: -85,
          duration: upBeat,
          ease: 'pow3.inOut',
        },
        0
      )
      .to('.wing-l, .wing-r', {
        rotationY: 0,
        duration: downBeat,
        ease: 'expo.inOut',
      });

    return tl;
  }

  function flapTlBlur() {
    let tl = new gsap.timeline();
    tl.to(
      blur,
      {
        px: 0,
        duration: upBeat / 2,
        ease: 'pow3.in',
      },
      0
    )
      .to(blur, {
        px: 2,
        duration: upBeat / 2,
        ease: 'pow3.out',
      })
      .to(blur, {
        px: 0,
        duration: downBeat / 2,
        ease: 'pow3.in',
      })
      .to(blur, {
        px: 0,
        duration: downBeat / 2,
        ease: 'pow3.out',
      });

    return tl;
  }

  flapTl.add(flapTlWing(), 0).add(flapTlBlur(), 0);

  let flapStepped = new gsap.timeline();

  document.querySelector('.big-logo').addEventListener('click', (e) => {
    if (!flapLock) {
      flapLock = true;

      let lastBlur;

      flapStepped.fromTo(
        flapTl,
        {
          progress: 0,
        },
        {
          progress: 1,
          duration: flapTl.totalDuration(),
          // ease: `steps(${Math.round(flapTl.totalDuration() * 25)})`,
          onUpdate: () => {
            if (blur.px != lastBlur) {
              gsap.set('.wing-l, .wing-r', { filter: 'blur(' + blur.px + 'px)' });
              lastBlur = blur.px;
            }
          },
          onComplete: () => {
            flapLock = false;
          },
        }
      );
    }
  });
})(window);
